import type { ReconciliationRow } from '../../../Reports/types/reconciliation'

export const RECONCILIATION_MODAL_DEV_FALLBACK_ROW: ReconciliationRow = {
  rotaInstanceId: 'dev',
  startTimeIso: '2026-03-25T09:00:00.000Z',
  teamMemberId: 'dev-tm',
  status: 'needs_attention',
  date: '2026-03-25',
  teamMember: { id: 'dev-tm', name: 'Jane Smith', avatarUrl: null },
  serviceUser: null,
  eventType: { id: 'evt1', name: 'Home visit' },
  plannedTime: {
    startTime: '2026-03-25T09:00:00.000Z',
    endTime: '2026-03-25T11:00:00.000Z',
    durationMinutes: 120
  },
  actualTime: {
    startTime: '2026-03-25T08:57:00.000Z',
    endTime: '2026-03-25T11:02:00.000Z',
    durationMinutes: 126
  },
  isCanceled: false,
  durationDiscrepancy: 6,
  warningCount: 0,
  warnings: [],
  payRate: { amount: '15.75', unit: 'hour', label: null },
  hasShiftRate: false,
  reconciliation: null
}

export const RECONCILIATION_MODAL_DEV_SHIFT_ROW: ReconciliationRow = {
  ...RECONCILIATION_MODAL_DEV_FALLBACK_ROW,
  rotaInstanceId: 'dev-shift',
  payRate: { amount: '89.50', unit: 'shift', label: null },
  hasShiftRate: true
}
